// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.scannerinventorying.inventory', {
        url: '/{inventoryId}',
        views: {
            "wideColumnView@stock": {
                templateUrl: 'main/stock/scannerinventorying/inventory/inventory.tpl.html',
                controller: 'InventoryController as vm'
            }
        },
        resolve: {
            inventoryHead: inventoryHeadResolver
        }
    });
}

// @ngInject
function inventoryHeadResolver($stateParams, InventoryingApiService) {
    return InventoryingApiService.getHeadInfoById($stateParams.inventoryId);
}

// @ngInject
function InventoryController($stateParams, $state, inventoryHead, InventoryingApiService, inventoryCorrectionsDialogService, ResourcesService, NewInventoryDialogService,
     loadSpinnerService, ArticleStocksHistoryDialogService, confirmationDialogService, printInventoryReportDialogService, ToasterService, $translate, $rootScope) {
    var vm = this;

    //Properties
    var inventoryId = $stateParams.inventoryId; 
    var totalsGrid = {};
    var detailsGrid = {};
    var summarizationGrid = {};
    var currentItemGroupId = 0;
    var inventoryRowsGrid = {};
    var inventoryOverviewGrid = {};
    var inventoryFileErrorGrid = {};
    var currentlyChosenMainGroupId = 0;
    var currentlyChosenBrandId = 0;
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.hasClaim = havePurchaseCostClaim();
    vm.uploadErrors = [];
    vm.inventoryFileErrors = [];
    vm.inventoryRows = [];
    vm.inventoryRowsAll = [];
    vm.autoAcceptLevel = 2;
    vm.displayLevel = 0;
    vm.totalValueThreshold = 500;
    vm.numberOfErrors = 0;
    vm.showAllErrors = false;
    vm.inventoryHead = inventoryHead.data;
    vm.inventoryHead.inventoryDate = vm.inventoryHead.inventoryDate.replace('T', ' ').substring(0, 19);
    vm.itemGroupInventoryRows = {};
    vm.isShowingUploadForm = false;
    vm.filterChoice = {
        showUnapproved: false,
        showAll: true,
        showApproved: false
    };
    vm.itemGroupTotals = {
        theoreticalBalance: 0,
        inventoried: 0,
        difference: 0,
        differenceValue: 0
    };
    vm.inventoryRowTotals = {
        theoreticalBalance: 0,
        inventoried: 0,
        difference: 0,
        totalValue: 0
    };
    vm.preliminaryTotals = {
        inventoried: 0,
        difference: 0,
        totalValue: 0
    }
    vm.overViewGridFilter = {
        mainGroups: false,
        brands: false
    };
    vm.totalsGridItems = [
        vm.inventoryRowTotals
    ];

    vm.statusIcons = {
        created: 'fa-upload',
        fileImported: 'fa-file-text-o',
        pending: 'fa-clock-o',
        completed: 'fa-check',
        deleted: 'fa-trash-o'
    };
    
    vm.typeIcons = {
        modelInventory: 'fa-tag',
        inventoryWhole: 'fa-archive',
        inventoryPart: 'fa-tags'
    }

    vm.information = {
        translations: {
            created: '',
            fileImported: '',
            pending: 'stock.inventory.pending.information',
            completed: 'stock.inventory.completed.information',
            deleted: 'stock.inventory.deleted.information'
        },
        backgroundColor: {
            created: 'rgba(0, 0, 0, 0)',
            fileImported: 'rgba(0, 0, 0, 0)',
            pending: 'rgba(255, 255, 0, 0.06)',
            completed: 'rgba(0,255,0,0.06)',
            deleted: 'rgba(255,0,0,0.03)',
        }
    };

    //Methods
    vm.showInventoryErrors = showInventoryErrors;
    vm.captureTotalsGrid = captureTotalsGrid;
    vm.captureDetailsGrid = captureDetailsGrid;
    vm.setCurrentItemGroup = setCurrentItemGroup;
    vm.approveItemGroup = approveItemGroup;
    vm.approveInventoryRow = approveInventoryRow;
    vm.expandArticlesGroups = expandArticlesGroups;
    vm.contractArticlesGroups = contractArticlesGroups;
    vm.openAnalyzeModal = openAnalyzeModal;
    vm.showUnApprovedItemGroups = showUnApprovedItemGroups;
    vm.showApprovedItemGroups = showApprovedItemGroups;
    vm.resetItemGroupsFiltering = resetItemGroupsFiltering;
    vm.showUnApprovedInventoryRows = showUnApprovedInventoryRows;
    vm.showApprovedInventoryRows = showApprovedInventoryRows;
    vm.resetInventoryRowsFiltering = resetInventoryRowsFiltering;
    vm.hasFileErrors = hasFileErrors;
    vm.captureInventoryRowsGrid = captureInventoryRowsGrid;
    vm.displayLevelChanged = displayLevelChanged;
    vm.autoAccept = autoAccept;
    vm.sendInventoryRowsForApproval = sendInventoryRowsForApproval;
    vm.captureSummarizationGrid = captureSummarizationGrid;
    vm.captureInventoryOverviewGrid = captureInventoryOverviewGrid;
    vm.captureInventoryFileErrorGrid = captureInventoryFileErrorGrid;
    vm.inventoryFileErrorGrid = inventoryFileErrorGrid;
    vm.fetchMainGroups = fetchMainGroups;
    vm.fetchBrands = fetchBrands;
    vm.getMainGroupInventoryRows = getMainGroupInventoryRows;
    vm.getBrandInventoryRows = getBrandInventoryRows;
    vm.uploadAndParseFile = uploadAndParseFile;
    vm.toggleUploadFormVisibility = toggleUploadFormVisibility;
    vm.acceptInventory = acceptInventory;
    vm.printInventoryReport = printInventoryReport;
    vm.loadItemGroupsInventoryRows = loadItemGroupsInventoryRows;
    vm.openCorrectionsModal = openCorrectionsModal;
    vm.loadInventoryFileErrors = loadInventoryFileErrors;
    vm.returnToList = returnToList;
    vm.openNewInventoryModal = openNewInventoryModal;

    activate();

    function activate() {
        fetchMainGroups();
        loadInventoryFileErrors();
    }

    function getMainGroupInventoryRows(mainGroupId) {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.getMainGroupInventoryRows(inventoryId, mainGroupId).then(function(response) {

            vm.inventoryRows = response.data;
            vm.inventoryRowsAll = vm.inventoryRows;

            inventoryRowsGrid.itemsSource = vm.inventoryRows;
            inventoryRowsGrid.invalidate();
            recalculateInventoryRowsTotals();
            inventoryRowsGrid.collapseGroupsToLevel(vm.displayLevel);
            resetInventoryRowsFiltering();
            currentlyChosenMainGroupId = mainGroupId;
        }, function(error) {
            handleError(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getBrandInventoryRows(brandId) {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.getBrandInventoryRows(inventoryId, brandId).then(function(response) {

            vm.inventoryRows = response.data;
            vm.inventoryRowsAll = response.data;

            inventoryRowsGrid.itemsSource = vm.inventoryRows;
            inventoryRowsGrid.invalidate();
            recalculateInventoryRowsTotals();
            inventoryRowsGrid.collapseGroupsToLevel(vm.displayLevel);
            resetInventoryRowsFiltering();
            currentlyChosenBrandId = brandId;
        }, function(error) {
            handleError(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function fetchMainGroups() {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.getInventoryMainGroups(inventoryId).then(function(response) {
            inventoryOverviewGrid.itemsSource = _.sortBy(response.data, function(mainGroup) {
                return mainGroup.mainGroupCode;
            });

            vm.preliminaryTotals = {
                inventoried: 0,
                difference: 0,
                totalValue: 0
            }

            _.forEach(response.data, function(mainGroup){
                vm.preliminaryTotals.inventoried += mainGroup.summarizedQuantity;
                vm.preliminaryTotals.difference += mainGroup.summarizedStockDifference;
                vm.preliminaryTotals.totalValue += mainGroup.summarizedTotalValue;
            })

            _.forEach(inventoryOverviewGrid.columns, function(column) {
                if (column.binding === "mainGroupDescription") {
                    column.width = "2*";
                } else if (column.binding === "brandDescription") {
                    column.width = 0;
                }
            });

            inventoryOverviewGrid.invalidate();

            vm.overViewGridFilter.mainGroups = true;
            vm.overViewGridFilter.brands = false;
        }, function(error) {
            handleError(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function fetchBrands() {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.getInventoryBrands(inventoryId).then(function(response) {
            inventoryOverviewGrid.itemsSource = _.sortBy(response.data, function(brand) {
                return brand.brandCode;
            });

            vm.preliminaryTotals = {
                inventoried: 0,
                difference: 0,
                totalValue: 0
            }
            
            _.forEach(response.data, function(brand){
                vm.preliminaryTotals.inventoried += brand.summarizedQuantity;
                vm.preliminaryTotals.difference += brand.summarizedStockDifference;
                vm.preliminaryTotals.totalValue += brand.summarizedTotalValue;
            })

            _.forEach(inventoryOverviewGrid.columns, function(column) {
                if (column.binding === "mainGroupDescription") {
                    column.width = 0;
                } else if (column.binding === "brandDescription") {
                    column.width = "2*";
                }
            });

            inventoryOverviewGrid.invalidate();

            vm.overViewGridFilter.mainGroups = false;
            vm.overViewGridFilter.brands = true;
        }, function(error) {
            handleError(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function reFetchOverViewGridData() {
        if (vm.overViewGridFilter.mainGroups) {
            fetchMainGroups();
        } else if (vm.overViewGridFilter.brands) {
            fetchBrands();
        }
    }

    function reFetchInventoryRowsGridData() {
        if (vm.overViewGridFilter.mainGroups) {
            getMainGroupInventoryRows(currentlyChosenMainGroupId);
        } else if (vm.overViewGridFilter.brands) {
            getBrandInventoryRows(currentlyChosenBrandId);
        }
    }

    function showUnApprovedInventoryRows() {
        resetInventoryRowsFiltering();

        vm.inventoryRows = _.filter(vm.inventoryRows, function(inventoryRow) {
            return !inventoryRow.isApproved;
        });

        vm.filterChoice.showUnapproved = true;
        vm.filterChoice.showAll = false;

        inventoryRowsGrid.itemsSource = vm.inventoryRows;

        updateInventoryRowsGridGroupings();
        recalculateInventoryRowsTotals();

        inventoryRowsGrid.collapseGroupsToLevel(vm.displayLevel);
    }

    function captureInventoryFileErrorGrid(sender) {
        inventoryFileErrorGrid = sender;
    }

    function captureInventoryOverviewGrid(sender) {
        inventoryOverviewGrid = sender;
        inventoryOverviewGrid.allowMerging = 'Cells';
        inventoryOverviewGrid.columns[0].allowMerging = true;
    }

    function captureSummarizationGrid(sender) {
        summarizationGrid = sender;
    }

    function showApprovedInventoryRows() {
        resetInventoryRowsFiltering();

        vm.inventoryRows = _.filter(vm.inventoryRows, function(inventoryRow) {
            return inventoryRow.isApproved;
        });

        vm.filterChoice.showApproved = true;
        vm.filterChoice.showAll = false;

        inventoryRowsGrid.itemsSource = vm.inventoryRows;

        updateInventoryRowsGridGroupings();
        recalculateInventoryRowsTotals();

        inventoryRowsGrid.collapseGroupsToLevel(vm.displayLevel);
    }

    function resetInventoryRowsFiltering() {
        vm.inventoryRows = vm.inventoryRowsAll;

        vm.filterChoice.showAll = true;
        vm.filterChoice.showUnapproved = false;
        vm.filterChoice.showApproved = false;

        inventoryRowsGrid.itemsSource = vm.inventoryRows;

        updateInventoryRowsGridGroupings();
        recalculateInventoryRowsTotals();

        inventoryRowsGrid.collapseGroupsToLevel(vm.displayLevel);
    }

    function expandArticlesGroups() {
        detailsGrid.collapseGroupsToLevel(detailsGrid.collectionView.groupDescriptions.length);
    }

    function displayLevelChanged() {
        console.log("InventoryRowsGrid:");
        console.log(inventoryRowsGrid);

        inventoryRowsGrid.collapseGroupsToLevel(vm.displayLevel);
    }

    function sendInventoryRowsForApproval() {
        var inventoryRows = [];

        _.forEach(vm.inventoryRows, function(invRow) {
            if (invRow.isApproved) {
                inventoryRows.push(invRow);
            }
        });

        console.log("InventoryRows to send for approval:");
        console.log(inventoryRows);

        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.approveInventoryRows(inventoryId, inventoryRows).then(function(response) {
            console.log("InventoryRows approved.");
            reFetchOverViewGridData();
        }, function(error) {
            handleError(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });

    }

    function autoAccept() {
        var groupedInventoryRows = {};
        var inventoryRowsToAccept = [];
        var autoAcceptLevel = parseInt(vm.autoAcceptLevel);

        var mainGroupNames;
        if (autoAcceptLevel === 0) {
            // Grouping
            groupedInventoryRows = _.groupBy(vm.inventoryRows, function(inventoryRow) {
                return (vm.overViewGridFilter.mainGroups) ? inventoryRow.mainGroupDescription : inventoryRow.brandDescription;
            });

            mainGroupNames = Object.keys(groupedInventoryRows);

            // Summarization
            _.forEach(mainGroupNames, function(mgName) {
                var invRows = groupedInventoryRows[mgName];
                var sum = _.reduce(invRows, function(memo, invRow) { return memo + invRow.totalValue; }, 0);
                if (Math.abs(sum) < vm.totalValueThreshold) {
                    _.forEach(invRows, function(invRow) { inventoryRowsToAccept.push(invRow); });
                }
            });
        } else if (autoAcceptLevel === 1) {
            // Grouping
            groupedInventoryRows = _.groupBy(vm.inventoryRows, function(inventoryRow) {
                return (vm.overViewGridFilter.mainGroups) ? inventoryRow.mainGroupDescription : inventoryRow.brandDescription;
            });

            mainGroupNames = Object.keys(groupedInventoryRows);
            _.forEach(mainGroupNames, function(mgName) {
                groupedInventoryRows[mgName] = _.groupBy(groupedInventoryRows[mgName], function(inventoryRow) {
                    return (vm.overViewGridFilter.mainGroups) ? inventoryRow.brandDescription : inventoryRow.mainGroupDescription;
                });
            });

            // Summarization
            _.forEach(mainGroupNames, function(mainGroupName) {
                _.forEach(groupedInventoryRows[mainGroupName], function(inventoryRows) {
                    var sum = _.reduce(inventoryRows, function(memo, invRow) { return memo + invRow.totalValue; }, 0);
                    if (Math.abs(sum) < vm.totalValueThreshold) {
                        _.forEach(inventoryRows, function(invRow) { inventoryRowsToAccept.push(invRow); });
                    }
                });
            });
        } else if (autoAcceptLevel === 2) {
            // Grouping
            groupedInventoryRows = _.groupBy(vm.inventoryRows, function(inventoryRow) {
                return (vm.overViewGridFilter.mainGroups) ? inventoryRow.mainGroupDescription : inventoryRow.brandDescription;
            });

            mainGroupNames = Object.keys(groupedInventoryRows);
            _.forEach(mainGroupNames, function(mgName) {
                groupedInventoryRows[mgName] = _.groupBy(groupedInventoryRows[mgName], function(inventoryRow) {
                    return (vm.overViewGridFilter.mainGroups) ? inventoryRow.brandDescription : inventoryRow.mainGroupDescription;
                });
            });

            _.forEach(mainGroupNames, function(mgName) {
                var brandNames = Object.keys(groupedInventoryRows[mgName]);
                _.forEach(brandNames, function(bName) {
                    groupedInventoryRows[mgName][bName] = _.groupBy(groupedInventoryRows[mgName][bName], function(inventoryRow) {
                        return inventoryRow.alternativeArticleNumber + inventoryRow.articleName;
                    });
                });
            });

            // Summarization
            _.forEach(mainGroupNames, function(mgName) {
                var brandNames = Object.keys(groupedInventoryRows[mgName]);
                _.forEach(brandNames, function(brandName) {
                    var articleNames = Object.keys(groupedInventoryRows[mgName][brandName]);
                    _.forEach(articleNames, function(articleName) {

                        var invRows = groupedInventoryRows[mgName][brandName][articleName];
                        var sum = _.reduce(invRows, function(memo, invRow) { return memo + invRow.totalValue; }, 0);
                        if (Math.abs(sum) < vm.totalValueThreshold) {
                            _.forEach(invRows, function(invRow) { inventoryRowsToAccept.push(invRow); });
                        }
                    });
                });
            });
        }

        console.log("groupedInventoryRows:");
        console.log(groupedInventoryRows);

        console.log("InventoryRowsToAccept:");
        console.log(inventoryRowsToAccept);

        _.forEach(inventoryRowsToAccept, function(invRow) {
            invRow.isApproved = true;
            invRow.isAutoApproved = true;
        });

        inventoryRowsGrid.invalidate();

        // Send the rows immediately.
        sendInventoryRowsForApproval();
    }

    function recalculateInventoryRowsTotals() {
        vm.inventoryRowTotals.inventoried = 0;
        vm.inventoryRowTotals.theoreticalBalance = 0;
        vm.inventoryRowTotals.difference = 0;
        vm.inventoryRowTotals.totalValue = 0;

        _.forEach(vm.inventoryRows, function(invRow) {
            vm.inventoryRowTotals.inventoried += invRow.quantity;
            vm.inventoryRowTotals.theoreticalBalance += invRow.theoreticalStockBalance;
            vm.inventoryRowTotals.difference += invRow.stockDifference;
            vm.inventoryRowTotals.totalValue += invRow.totalValue;
        });


    }

    function recalculateItemGroupTotals() {
        vm.itemGroupTotals.theoreticalBalance = 0;
        vm.itemGroupTotals.inventoried = 0;
        vm.itemGroupTotals.difference = 0;
        vm.itemGroupTotals.differenceValue = 0;

        _.forEach(vm.itemGroups, function(itemGroup) {
            vm.itemGroupTotals.theoreticalBalance += itemGroup.summarizedTransactionQuantity;
            vm.itemGroupTotals.inventoried += itemGroup.summarizedInventoryRowsQuantity;
            vm.itemGroupTotals.difference += itemGroup.difference;
            vm.itemGroupTotals.differenceValue += itemGroup.summarizedCostPrice;
        });
    }

    function setFilterChoiceFalse() {
        vm.filterChoice.showUnapproved = false;
        vm.filterChoice.showAll = false;
        vm.filterChoice.showApproved = false;
    }

    function contractArticlesGroups() {
        detailsGrid.collapseGroupsToLevel(0);
    }

    function captureInventoryRowsGrid(sender) {
        inventoryRowsGrid = sender;
        inventoryRowsGrid.collapseGroupsToLevel(0);

        console.log("inventoryRowsGrid");
        console.log(inventoryRowsGrid);

        recalculateInventoryRowsTotals();
    }

    function updateInventoryRowsGridGroupings() {
        inventoryRowsGrid.groupHeaderFormat = '{value} ({count})';

        var mainGroupGrouping = new wijmo.collections.PropertyGroupDescription('', function(item, prop) {
            return item.mainGroupDescription;
        });
        var brandGrouping = new wijmo.collections.PropertyGroupDescription('', function(item, prop) {
            return item.brandDescription;
        });
        var articleGrouping = new wijmo.collections.PropertyGroupDescription('', function(item, prop) {
            return item.alternativeArticleNumber + " " + item.articleName;
        });

        if (vm.overViewGridFilter.mainGroups) {
            inventoryRowsGrid.collectionView.groupDescriptions.push(mainGroupGrouping);
            inventoryRowsGrid.collectionView.groupDescriptions.push(brandGrouping);
        } else {
            inventoryRowsGrid.collectionView.groupDescriptions.push(brandGrouping);
            inventoryRowsGrid.collectionView.groupDescriptions.push(mainGroupGrouping);
        }

        var articleVariant1SortOrderSortDescription = new wijmo.collections.SortDescription("variantDetail1Name", 'true');
        var articleVariant2SortOrderSortDescription = new wijmo.collections.SortDescription("variantDetail2SortOrder", 'true');

        inventoryRowsGrid.collectionView.groupDescriptions.push(articleGrouping);

        inventoryRowsGrid.collectionView.sortDescriptions.push(articleVariant1SortOrderSortDescription);
        inventoryRowsGrid.collectionView.sortDescriptions.push(articleVariant2SortOrderSortDescription);

        inventoryRowsGrid.invalidate();
        inventoryRowsGrid.collectionView.refresh();
    }

    function showUnApprovedItemGroups() {
        resetItemGroupsFiltering();

        vm.itemGroups = _.filter(vm.itemGroups, function(itemGroup) {
            return !itemGroup.isApproved;
        });

        setFilterChoiceFalse();
        vm.filterChoice.showUnapproved = true;

        totalsGrid.itemsSource = vm.itemGroups;
        updateTotalsGridGroupings();
        recalculateItemGroupTotals();
    }

    function showApprovedItemGroups() {
        resetItemGroupsFiltering();

        vm.itemGroups = _.filter(vm.itemGroups, function(itemGroup) {
            return itemGroup.isApproved;
        });

        setFilterChoiceFalse();
        vm.filterChoice.showApproved = true;

        totalsGrid.itemsSource = vm.itemGroups;
        updateTotalsGridGroupings();
        recalculateItemGroupTotals();
    }

    function resetItemGroupsFiltering() {
        vm.itemGroups = vm.allItemGroups;

        setFilterChoiceFalse();
        vm.filterChoice.showAll = true;

        totalsGrid.itemsSource = vm.itemGroups;
        updateTotalsGridGroupings();
        recalculateItemGroupTotals();
    }

    function approveItemGroup(itemGroup) {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.approveItemGroupRelatedRows(inventoryId, itemGroup.id).then(function(response) {
            console.log("Success");
            vm.loadItemGroupsInventoryRows(itemGroup.id);
            itemGroup.isApproved = true;
            totalsGrid.invalidate();
        }, function(error) {
            handleError(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function openAnalyzeModal(articleId, inventoryId, variantDetail1Id) {
        ArticleStocksHistoryDialogService.showDialog(articleId, inventoryId, variantDetail1Id);
    }

    function approveInventoryRow(inventory) {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.approveInventoryRow(inventoryId, inventory.id).then(function() {
            console.log("Success. Now set the isApproved of the object");
            inventory.isApproved = true;
            detailsGrid.invalidate();
        }, function(error) {
            handleError(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function loadItemGroupsInventoryRows(itemGroupId) {
        InventoryingApiService.getInventoryRowsRelatedToItemGroup(inventoryId, itemGroupId).then(function(response) {
            console.log("Got the following inventoryRows related to the itemGroup:");
            console.log(response);
            vm.itemGroupInventoryRows = response.data;
        }, function(error) {
            handleError(error);
        });
    }

    function hasFileErrors() {
        return vm.inventoryFileErrors.length > 0;
    }

    function showInventoryErrors() {
        vm.showAllErrors = !vm.showAllErrors;
        if (vm.showAllErrors) {
            vm.loadInventoryFileErrors();
        }
    }

    function loadInventoryFileErrors() {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.getInventoryFileErrors(inventoryId).then(function(response) {
            console.log("Got the following inventory file upload errors:");
            console.log(response);
            vm.numberOfErrors = response.data.errorRows.length;
            vm.inventoryFileErrors = response.data.errorRows;
            inventoryFileErrorGrid.itemsSource = response.data.errorRows;
            inventoryFileErrorGrid.invalidate();
        }, function(error) {
            handleError(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function setCurrentItemGroup(itemGroupId) {
        currentItemGroupId = itemGroupId;
    }

    function openCorrectionsModal(articleId) {
        console.log("openCorrectionsModal with articleId: " + articleId + " and inventoryId: " + inventoryId);
        inventoryCorrectionsDialogService.showDialog(inventoryId, articleId).then(function(result) {
            if (result) {
                vm.loadItemGroupsInventoryRows(currentItemGroupId);
                reFetchOverViewGridData();
                updateLocalInventoryRows(result.data);
            }
        });
    }

    function updateLocalInventoryRows(inventoryRows) {
        _.forEach(inventoryRows, function(inventoryRow) {
            var inventoryRowToUpdate = _.find(vm.inventoryRowsAll, function(invRow) {
               return invRow.id === inventoryRow.id;
            });
            inventoryRowToUpdate.quantity = inventoryRow.quantity;
            inventoryRowToUpdate.stockDifference =  inventoryRowToUpdate.quantity - inventoryRowToUpdate.theoreticalStockBalance;
        });

        inventoryRowsGrid.invalidate();
    }

    function captureTotalsGrid(sender) {
        totalsGrid = sender;
        totalsGrid.itemsSource = vm.itemGroups;

        updateTotalsGridGroupings();

        showUnApprovedItemGroups();
        recalculateItemGroupTotals();
    }

    function updateTotalsGridGroupings() {
        totalsGrid.groupHeaderFormat = '{value} ({count})';

        var mainGroupDescription = new wijmo.collections.PropertyGroupDescription('', function(item, prop) {
            return item.itemGroup.mainGroup.mainGroupDescription;
        });

        totalsGrid.collectionView.groupDescriptions.push(mainGroupDescription);

        totalsGrid.collapseGroupsToLevel(0);
    }

    function captureDetailsGrid(sender) {
        detailsGrid = sender;
    }

    function setDetailsGridData() {
        detailsGrid.itemsSource = vm.itemGroupInventoryRows;
        detailsGrid.groupHeaderFormat = '{value} ({count})';

        var articleNameDescription = new wijmo.collections.PropertyGroupDescription('', function(item, prop) {
            return item.article.articleName;
        });
        var variant1Description = new wijmo.collections.PropertyGroupDescription('', function(item, prop) {
            return item.articleVariant.variantDetail1.variantDetailName;
        });

        detailsGrid.collectionView.groupDescriptions.push(articleNameDescription);
        detailsGrid.collectionView.groupDescriptions.push(variant1Description);

        detailsGrid.invalidate();
        detailsGrid.collectionView.refresh();
    }

    function uploadAndParseFile() {
        vm.uploadErrors = [];
        var fileInputDomElement = $("#inventoryingFileUploadElement")[ 0 ];
        var file = fileInputDomElement.files[0];
        var reader = new FileReader();

        reader.onload = onLoadFunction;

        reader.readAsArrayBuffer(file);

        function onLoadFunction(e) {
            try {

                var data = "";
                var bytes = new Uint8Array(e.target.result);
                var length = bytes.byteLength;
                for (var i = 0; i < length; i++) {
                    data += String.fromCharCode(bytes[i]);
                }

                var sendData = {
                    fileName: file.name,
                    data: data
                };

                loadSpinnerService.start('mainSpinner');
                InventoryingApiService.uploadInventoryFile(inventoryId, sendData).then(function(response) {
                    console.log(response);
                    $state.go($state.current, {inventoryId: inventoryId}, {reload: true});
                }, function(error) {
                    console.log(error);
                    vm.uploadErrors.push({message: "Could not add file."});
                }).finally(function() {
                    loadSpinnerService.stop('mainSpinner');
                });

            } catch (error) {
                console.log(error);
            } finally {
            }
        }
    }

    function acceptInventory() {
        var message = $translate.instant('inventory.confirmAccept');
        confirmationDialogService.showDialog(message).then(function(response) {
            if (response) {
                InventoryingApiService.queueInventoryForFinalization(inventoryId).then(function(response) {
                    $state.go($state.current, {inventoryId: inventoryId}, {reload: true});
                }, function(error) {
                    ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    console.log(error);
                }).finally(function(){
                    ToasterService.showSuccess($translate.instant("common.approved"));
                });
            }
        });
    }

    function toggleUploadFormVisibility() {
        vm.isShowingUploadForm = !vm.isShowingUploadForm;
        inventoryFileErrorGrid.invalidate();
    }

    function printInventoryReport() {
        printInventoryReportDialogService.showDialog().then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                InventoryingApiService.getInventoryReport(inventoryId, result.languageCode, result.printFormat).then(function(response) {

                }, function(error) {
                    ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function returnToList(){
        $state.go('stock.scannerinventorying', {prev: inventoryId}, {reload: true});
    }

    function openNewInventoryModal() {
        NewInventoryDialogService.showDialog().then(function(result) {
            if (result && result.success) {
                $state.go('stock.scannerinventorying.inventory', {inventoryId: result.inventoryItem.id});
            }
            else{
                returnToList();
            }
        });
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }

    function havePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined){
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.read){
            return false
        }

        return true
    }

}

angular.module('scannerinventorying.inventory', ['scannerinventorying.inventory.articledetails'])
    .config(stateConfig)
    .controller('InventoryController', InventoryController);
